import { IonIcon, IonItem, IonLabel, IonList } from '@ionic/react';
import { chevronForwardOutline } from 'ionicons/icons';
import React from 'react';
import { getConfig } from '../../appConfig';
import Basket from '../../lib/basket';
import { withTranslation } from '../../lib/translate';
import { forwardTo } from '../../lib/utils';
import { Spacer, StrongText } from '../common';

const CuratedMenusLink = ({ __, onClick, saveOrderData }) => {
	if (!getConfig().flags?.hasCuratedMenus) {
		return null;
	}
	return (
		<>
			<IonList className="box-wrapper" lines="none">
				<IonItem
					className="pointer"
					onClick={() => {
						if (onClick) {
							onClick();
						}
						forwardTo('/curated-menus', { orderType: Basket.getDeliveryOption()?.id, saveOrderData });
					}}
				>
					<IonLabel className="break-space">
						<StrongText className="block text-to-update">{__('Browse curated menus')}</StrongText>
					</IonLabel>
					<IonIcon style={{ height: '18px', width: '18px' }} slot="end" icon={chevronForwardOutline} />
				</IonItem>
			</IonList>
			<Spacer size={2} />
		</>
	);
};

export default withTranslation(CuratedMenusLink);
